export default {
    // Profiles
    driverPerformanceConfig_riskEvents_profiles: "Perfiles",
    // Category
    driverPerformanceConfig_riskEvents_category: "Categoría",
    driverPerformanceConfig_riskEvents_eventName: "Nombre del Evento",
    driverPerformanceConfig_riskEvents_status: "Estado",
    driverPerformanceConfig_riskEvents_inactive: "Inactivo",
    driverPerformanceConfig_riskEvents_active: "Activo",
    // Risk Events
    driverPerformanceConfig_riskEvents_severityMappingTooltip: "Permite establecer las escalas para los valores de riesgo del evento.",
    driverPerformanceConfig_riskEvents_coachableTooltip: "Habilitar este evento para el módulo de entrenamiento.",
    driverPerformanceConfig_riskEvents: "Eventos de Riesgo",
    driverPerformanceConfig_riskEvents_save: "Guardar",
    driverPerformanceConfig_riskEvents_cancel: "Cancelar",
    driverPerformanceConfig_riskEvents_severityMapping: "Mapa de Severidad",
    driverPerformanceConfig_riskEvents_start: "Inicio",
    driverPerformanceConfig_riskEvents_low: "Bajo",
    driverPerformanceConfig_riskEvents_medium: "Medio",
    driverPerformanceConfig_riskEvents_high: "Alto",
    driverPerformanceConfig_riskEvents_critical: "Crítico",
    driverPerformanceConfig_riskEvents_edit: "Editar",
    driverPerformanceConfig_riskEvents_coachable: "Entrenable",
    driverPerformanceConfig_riskEvents_absolute: "Absoluto",
    driverPerformanceConfig_riskEvents_relative: "Relativo",
    driverPerformanceConfig_riskEvents_eventCreatedSuccessfully: "Evento creado correctamente.",
    driverPerformanceConfig_riskEvents_eventUpdatedSuccessfully: "Evento actualizado correctamente.",
    driverPerformanceConfig_riskEvents_eventDeletedSuccessfully: "Evento borrado correctamente.",

    // Category translations
    driverPerformanceConfig_riskEvents_category_aggression: 'Agresión',
    driverPerformanceConfig_riskEvents_category_adas: 'ADAS',
    driverPerformanceConfig_riskEvents_category_dms: 'DMS',

    //Modal no save changes
    driverPerformanceConfig_riskEvents_modalNoSaveChanges_title: "Recuerda guardar los cambios",
    driverPerformanceConfig_riskEvents_modalNoSaveChanges_content: "Si quieres perder los ajustes, haz clic en Aceptar. De lo contrario, haz clic en Cancelar para volver a la pantalla y poder guardar los cambios.",
    driverPerformanceConfig_riskEvents_modalNoSaveChanges_accept: "Aceptar",
    driverPerformanceConfig_riskEvents_modalNoSaveChanges_cancel: "Cancelar",
};